import { observer } from 'mobx-react-lite'
import { Icon, type ITooltipProps, Switch, Tooltip, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type ISurveySwitchProps = {
  label: string
  active: boolean
  onToggle: (value: boolean) => void
  tooltipProps?: ITooltipProps
}

export const SurveySwitch = observer(
  ({ label, active, onToggle, tooltipProps }: ISurveySwitchProps) => {
    return (
      <div className={styles.toggleRow}>
        <span className={styles.label}>
          <Typography
            variant='text-input-field-r'
            color={'var(--content-primary-tertiary)'}
            ariaLabel={label}
          >
            {label}
          </Typography>
          {!!tooltipProps && (
            <Tooltip {...tooltipProps}>
              <span className={styles.tooltipIcon}>
                <Icon icon='question' fontSize={16} color={'var(--content-neutral-primary)'} />
              </span>
            </Tooltip>
          )}
        </span>
        <Switch value={active} onChange={onToggle} />
      </div>
    )
  }
)
